import StartupPage from "./pages/StartupPage";
function App() {
  return (
    <div className="App">
      <StartupPage />
    </div>
  );
}

export default App;
